import React from 'react'
import { ChatBubbleLeftIcon, ClockIcon, EllipsisVerticalIcon } from '@heroicons/react/24/outline'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import moment from 'moment'

const ChatHistoryList = ({ chatHistoryData, onChatClick, activeFlowId }) => {
  
  const formatTimestamp = (timestamp) => {
    return moment(timestamp).fromNow()
  }

  const getPreviewText = (flow) => {
    // First try to get preview from originalTask
    if (flow.originalTask) {
      return flow.originalTask.length > 100 ? flow.originalTask.substring(0, 100) + '...' : flow.originalTask
    }

    // Fallback to chatHistory if available
    if (flow.chatHistory && flow.chatHistory.length > 0) {
      const firstUserMessage = flow.chatHistory.find(msg => msg.role === 'user')
      if (firstUserMessage && firstUserMessage.content) {
        return firstUserMessage.content.length > 100 ? firstUserMessage.content.substring(0, 100) + '...' : firstUserMessage.content
      }
    }

    // Final fallback to description or default
    return flow.description || 'No preview available'
  }

  const getMessageCount = (flow) => {
    return flow.chatHistory ? flow.chatHistory.length : 0
  }

  return (
    <div className="h-full overflow-y-auto">
      {chatHistoryData.map((flow) => {
        const isActive = flow.flowId === activeFlowId
        return (
          <div
            key={flow._id || flow.id}
            className={`group relative border-b border-gray-100 last:border-b-0 transition-colors duration-150 cursor-pointer ${
              isActive 
                ? 'bg-gray-100 border-l-4 border-l-gray-400 hover:bg-gray-200' 
                : 'hover:bg-gray-50'
            }`}
            onClick={() => onChatClick(flow)}
          >
        
          <div className="px-4 py-3">
            <div className="flex items-start justify-between gap-3">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <ChatBubbleLeftIcon className="h-4 w-4 text-gray-400 flex-shrink-0" />
                  <h3 className="text-sm font-medium text-gray-900 truncate">
                    {flow.title || (flow.originalTask ? (flow.originalTask.length > 50 ? flow.originalTask.substring(0, 50) + '...' : flow.originalTask) : 'Untitled Conversation')}
                  </h3>
                </div>

                <p className="text-xs text-gray-600 line-clamp-2 leading-relaxed mb-2">
                  {getPreviewText(flow)}
                </p>

                <div className="flex items-center justify-between text-xs text-gray-500">
                  <div className="flex items-center gap-1">
                    <ClockIcon className="h-3 w-3" />
                    <span>{formatTimestamp(flow.createdAt || flow.updatedAt)}</span>
                  </div>
                  {getMessageCount(flow) > 0 && (
                    <span className="bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full text-xs font-medium">
                      {getMessageCount(flow)} messages
                    </span>
                  )}
                </div>
              </div>

              <Menu as="div" className="relative flex-shrink-0">
                <MenuButton
                  className="opacity-0 group-hover:opacity-100 transition-opacity p-1 hover:bg-gray-200 rounded"
                  onClick={(e) => e.stopPropagation()}
                >
                  <EllipsisVerticalIcon className="h-4 w-4 text-gray-500" />
                </MenuButton>
                <MenuItems className="absolute right-0 z-10 mt-1 w-32 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <MenuItem>
                    <button
                      className="block px-3 py-1 text-xs text-gray-700 hover:bg-gray-100 w-full text-left"
                      onClick={(e) => {
                        e.stopPropagation()
                        onChatClick(flow)
                      }}
                    >
                      Open Chat
                    </button>
                  </MenuItem>
                  <MenuItem>
                    <button className="block px-3 py-1 text-xs text-red-600 hover:bg-gray-100 w-full text-left">
                      Delete
                    </button>
                  </MenuItem>
                </MenuItems>
              </Menu>
            </div>
          </div>
        </div>
        )
      })}
    </div>
  )
}

export default ChatHistoryList